module.exports = __webpack_public_path__ + "img/DSC_7085.a5043ca6.png";